import { render, staticRenderFns } from "./DisplayGroupForm.vue?vue&type=template&id=ab1add9a"
import script from "./DisplayGroupForm.vue?vue&type=script&lang=js"
export * from "./DisplayGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports